import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hyshqy_ic_arrow_right",
  "use": "icon-hyshqy_ic_arrow_right-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"icon-hyshqy_ic_arrow_right\">\n  <defs>\n    <style>\n      #icon-hyshqy_ic_arrow_right .cls-1 {\n        fill: #999;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"m5,8.5c-.11,0-.22-.04-.31-.11-.22-.17-.25-.49-.08-.7l1.75-2.19-1.75-2.19c-.17-.22-.14-.53.08-.7.22-.17.53-.14.7.08l1.75,2.19c.29.37.29.88,0,1.25l-1.75,2.19c-.1.12-.24.19-.39.19Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hyshqy_ic_arrow_right.svg
// module id = ykuz
// module chunks = 87